interface ChapterTimelineItem {
  id: string;
  name: string;
  president: string;
  inceptionYear: number;
  location: string;
}

interface ChaptersTimelineProps {
  chapters?: ChapterTimelineItem[];
}

export function ChaptersTimeline({ chapters }: ChaptersTimelineProps) {
  if (!chapters || chapters.length === 0) return null;

  const containerStyle: React.CSSProperties = {
    width: '100%',
    height: '200px',
    background: '#0d1b12',
    borderTop: '2px solid rgba(255, 255, 255, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    overflow: 'hidden',
    position: 'relative',
    padding: '0 32px',
    boxSizing: 'border-box',
  };

  const trackStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    position: 'relative',
    width: '100%',
  };

  const lineStyle: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    height: '3px',
    background: '#c9a84c',
    transform: 'translateY(-50%)',
  };

  const nodeStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    position: 'relative',
    maxWidth: '160px',
  };

  const dotStyle: React.CSSProperties = {
    width: '14px',
    height: '14px',
    borderRadius: '50%',
    background: '#c9a84c',
    border: '3px solid #0d1b12',
    boxShadow: '0 0 0 2px #c9a84c',
    zIndex: 1,
  };

  const yearStyle: React.CSSProperties = {
    fontSize: '16px',
    fontWeight: 700,
    color: '#c9a84c',
    marginBottom: '10px',
  };

  const nameStyle: React.CSSProperties = {
    fontSize: '14px',
    fontWeight: 700,
    color: '#ffffff',
    marginTop: '10px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '140px',
  };

  const presidentStyle: React.CSSProperties = {
    fontSize: '11px',
    color: '#e0e0e0',
    marginTop: '3px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '140px',
  };

  return (
    <div style={containerStyle}>
      <div style={{ position: 'relative', width: '100%' }}>
        <div style={trackStyle}>
          <div style={lineStyle} />
          {chapters.map((chapter) => (
            <div key={chapter.id} style={nodeStyle}>
              <span style={yearStyle}>{chapter.inceptionYear}</span>
              <div style={dotStyle} />
              <span style={nameStyle}>{chapter.name}</span>
              <span style={presidentStyle}>{chapter.president}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
